// Typelizer digest 77fa210bd3254176a0a32cb43914460f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /registration/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/registration/new', {}, options),
    method: 'get',
  }),

  /** POST /registration */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/registration', {}, options),
    method: 'post',
  }),
}
